<div class="static" *ngIf="loading">
  <div style="position: absolute; left: 50%; top: 45%;" class="lds-ellipsis"><div></div><div></div><div></div>
</div>

